// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../../elements/Modal/Modal';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import Loading from '../../../../../../elements/Loading/Loading';
import { FormValidator } from '../../../../../../utils/form/index';
import { resetState } from '../../../duck';

import style from './RecoverUserModal.scss';
import buttonStyle from '../../../../../../assets/styles/button.scss';
import inputStyle from '../../../../../../assets/styles/input.scss';
import formStyle from '../../../../../../assets/styles/form.scss';
import yogi from '../../../../../../assets/img/home/yogi-qempo_2.png';
import yogiSad from '../../../../../../assets/img/YOGI-SAD.png';

import type { HTTPError } from '../../../../../../error/index';
import type { FormValidationResult } from '../../../../../../utils/form';

type Props = {
  +isOpen: boolean;
  +recoverUser: (password: string, token: string) => void;
  +isRecoveringUser?: boolean;
  +recoverUserError?: HTTPError;
  +recoverUserSuccess?: boolean;
  +forgotPasswordToken?: string;
  +handleClose: () => void;
  +resetState: () => void;
  +changePasswordModalVisible?: boolean;
};

type State = {
  password: {
    value: string;
    errors?: string[];
  };
  repeatPassword: {
    value: string;
    errors?: string[];
  };
};

export default class RecoverUserModal extends Component<Props, State> {
  formValidatorPasswords: FormValidator;
  state = {
    password: {
      value: '',
    },
    repeatPassword: {
      value: '',
    },
  };

  constructor(props: Props) {
    super(props);
    this.formValidatorPasswords = new FormValidator({
      password: {
        required: 'required',
        min: (value: string) => value.length < 8,
      },
      repeatPassword: {
        required: (values: string[]) => !values[0],
        notSame: (values: string[]) => values[0] !== values[1]
      }
    });
  }

  componentWillUnmount() {
    const { resetState } = this.props;
    resetState();
  }


  handleChangePasswords(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  }

  handleBlurPasswords(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      const v = name === 'repeatPassword' ? [value, this.state.password.value] : value;

      const errors = this.formValidatorPasswords.validateField(name, v);
      if (errors.length && (errors[0] === 'notSame' || errors[0] === 'min')) {
        this.setState({ [name]: { value, errors } });
      } else {
        this.setState({ [name]: { value } });
      }
    }
  }

  handleFocusPasswords(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  }

  handleSubmit(e: Event) {
    e.preventDefault();
    const { recoverUser, forgotPasswordToken } = this.props;
    const passwordValue = this.state.password.value;
    const repeatPasswordValue = this.state.repeatPassword.value;
    const errors = this.formValidatorPasswords.validateForm({
      password: passwordValue,
      repeatPassword: [repeatPasswordValue, passwordValue],
    });
    if (errors.length) {
      errors.forEach((error: FormValidationResult) =>
        this.setState({ [error.field]: { ...this.state[error.field], errors: error.errors } }));
    } else if (forgotPasswordToken) {
      recoverUser(passwordValue, forgotPasswordToken);
    }
  }

  builderScene() {
    const { password, repeatPassword } = this.state;
    const { isRecoveringUser, recoverUserSuccess, recoverUserError } = this.props;
    if (isRecoveringUser) {
      return <Loading type="sk-three-bounce"
                      className={style.modalLoading}
                      number={3}/>
    } else if (recoverUserSuccess) {
      return <Fragment>
        <img src={yogi}
             alt="happy yogi"/>
        <FormattedMessage id="modal.recoverUser.success.title">{
          text => <h1>{text}</h1>
        }</FormattedMessage>
      </Fragment>
    } else if (recoverUserError) {
      return <Fragment>
        <img src={yogiSad}
             alt="happy yogi"/>
        <FormattedMessage id="httpErrors.fetch.500">{
          text => <p>{text}</p>
        }</FormattedMessage>
      </Fragment>
    } else {
      const passwordError = password.errors && FormValidator.buildErrorLabel(password.errors, {
        required: 'preferences.password.newPassword.error.required',
        min: 'preferences.password.newPassword.error.min',
      });
      const repeatPasswordError = repeatPassword.errors && FormValidator.buildErrorLabel(repeatPassword.errors, {
        required: 'preferences.password.repeatNewPassword.error.required',
        min: 'preferences.password.repeatNewPassword.error.min',
        notSame: 'preferences.password.repeatNewPassword.error.notSame',
      });

      return (
        <form className={classNames(style.authForm, formStyle.formWrap)}
              onSubmit={this.handleSubmit.bind(this)}>
          {/*<section className={classNames(formStyle.row, formStyle.inputRow)}>
            <FormattedMessage id="auth.email.label">{
              txt => (<label className={formStyle.label}>{txt}</label>)
            }</FormattedMessage>
            <input type="password"
                   className={classNames(inputStyle.input,
                     { [inputStyle.red]: email.errors && email.errors.length },
                     { [inputStyle.lightBlue]: !!email.value })}
                   onChange={this.handleChange.bind(this)}
                   onFocus={this.handleFocus.bind(this)}
                   onBlur={this.handleBlur.bind(this)}
                   disabled={isSendingForgotPassword}
                   name="password"
                   placeholder={this.context.intl.formatMessage(messages.emailPlaceholder)}/>
            {emailError}
          </section>*/}
          <FormattedMessage id="modal.sendForgotPassword.title">{
            text => <h1>{text}</h1>
          }</FormattedMessage>
          <section className={classNames(formStyle.row, formStyle.inputRow)}>
            <FormattedMessage id="preferences.password.newPassword.label">{
              txt => <label className={formStyle.label}>{txt}</label>
            }</FormattedMessage>
            <input name="password"
                   className={classNames(inputStyle.input,
                     { [inputStyle.red]: password.errors && password.errors.length },
                     { [inputStyle.lightBlue]: !!password.value })}
                   disabled={isRecoveringUser}
                   onChange={this.handleChangePasswords.bind(this)}
                   onBlur={this.handleBlurPasswords.bind(this)}
                   onFocus={this.handleFocusPasswords.bind(this)}
                   type="password"
                   value={password.value}/>
            {passwordError}
          </section>
          <section className={classNames(formStyle.row, formStyle.inputRow)}>
            <FormattedMessage id="preferences.password.repeatNewPassword.label">{
              txt => <label className={formStyle.label}>{txt}</label>
            }</FormattedMessage>
            <input name="repeatPassword"
                   className={classNames(inputStyle.input,
                     { [inputStyle.red]: repeatPassword.errors && repeatPassword.errors.length },
                     { [inputStyle.lightBlue]: !!repeatPassword.value })}
                   disabled={isRecoveringUser}
                   onChange={this.handleChangePasswords.bind(this)}
                   onBlur={this.handleBlurPasswords.bind(this)}
                   onFocus={this.handleFocusPasswords.bind(this)}
                   type="password"
                   value={repeatPassword.value}/>
            {repeatPasswordError}
          </section>
          <FormattedMessage id="preferences.password.updatePassword">{
            txt => (
              <button
                type="submit"
                disabled={isRecoveringUser}
                className={classNames(buttonStyle.btn, buttonStyle.lightBlue, style.submitBtn)}
                onClick={this.handleSubmit.bind(this)}>{txt}
              </button>
            )
          }</FormattedMessage>
        </form>
      )
    }
  }

  render() {
    const { isRecoveringUser, handleClose, changePasswordModalVisible } = this.props;
    return (
      <Modal open={changePasswordModalVisible}
             width={544}
             height={616}
             handleClose={() => !isRecoveringUser && handleClose()}>
        <section className={style.changePasswordModal}>
          {this.builderScene()}
        </section>
      </Modal>
    )
  }
}

RecoverUserModal.propTypes = {
  isOpen: PropTypes.bool,
  recoverUser: PropTypes.func.isRequired,
  isRecoveringUser: PropTypes.bool,
  recoverUserError: PropTypes.object,
  forgotPasswordToken: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  recoverUserSuccess: PropTypes.bool,
  resetState: PropTypes.func.isRequired,
  changePasswordModalVisible: PropTypes.bool,
};

RecoverUserModal.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/forgot-password-modal/components/RecoverUserModal/RecoverUserModal.jsx